/* Delivery & pickup availability block. Fetches store-level stock via the Storefront GraphQL API. */
(function () {
  var STOREFRONT_API_VERSION = typeof storeFrontApiVersion !== 'undefined' ? storeFrontApiVersion : '2026-01';
  var COOKIE_NAME = 'fulfilment_preferred_branch';
  var COOKIE_MAX_AGE_DAYS = 90;
  var DELIVERY_ELIGIBLE_METAOBJECT_TYPE = 'fl_ecommerce_locations';

  var QUERY = [
    'query FulfilmentAvailability($id: ID!, $first: Int!) {',
    '  node(id: $id) {',
    '    ... on ProductVariant {',
    '      id',
    '      currentlyNotInStock',
    '      storeAvailability(first: $first) {',
    '        edges {',
    '          node {',
    '            available',
    '            quantityAvailable',
    '            pickUpTime',
    '            location {',
    '              id',
    '              name',
    '              address {',
    '                address1',
    '                address2',
    '                city',
    '                province',
    '                zip',
    '                phone',
    '              }',
    '            }',
    '          }',
    '        }',
    '      }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  var METAOBJECT_QUERY = [
    'query DeliveryEligibleLocations($type: String!, $first: Int!) {',
    '  metaobjects(type: $type, first: $first) {',
    '    nodes {',
    '      shopifyLocationId: field(key: "shopify_location_id") { value }',
    '      fulfilmentLocation: field(key: "fulfilment_location") { value }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  function parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function formatAddress(address) {
    if (!address) return '';
    return [address.address1, address.address2, address.city, address.province, address.zip]
      .filter(Boolean)
      .join(', ');
  }

  // Some metaobject field types return `value` JSON-encoded (the string includes its own
  // surrounding quotes) rather than as a bare string. Unwraps that if present.
  function unwrapMetaobjectValue(value) {
    if (typeof value !== 'string' || value.charAt(0) !== '"') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  // Returns the trailing numeric id from a Shopify GID, or the value unchanged if it isn't one.
  function extractNumericId(value) {
    if (!value) return '';
    var str = String(value);
    var lastSlash = str.lastIndexOf('/');
    return lastSlash === -1 ? str : str.slice(lastSlash + 1);
  }

  var tooltipCount = 0;
  var TOOLTIP_VIEWPORT_MARGIN = 16;

  // Info-icon tooltip: opens on mouse hover, keyboard focus, or click/tap of the trigger.
  if (!customElements.get('fulfilment-tooltip')) {
    customElements.define(
      'fulfilment-tooltip',
      class FulfilmentTooltip extends HTMLElement {
        constructor() {
          super();
          this.pinned = false;
          this.hovered = false;

          this.onPointerEnter = this.onPointerEnter.bind(this);
          this.onPointerLeave = this.onPointerLeave.bind(this);
          this.onFocusIn = this.onFocusIn.bind(this);
          this.onFocusOut = this.onFocusOut.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onTriggerClick = this.onTriggerClick.bind(this);
          this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        }

        connectedCallback() {
          this.trigger = this.querySelector('.fulfilment-tooltip__trigger');
          this.content = this.querySelector('.fulfilment-tooltip__content');
          if (!this.trigger || !this.content) return;

          if (!this.content.id) this.content.id = 'FulfilmentTooltip-' + ++tooltipCount;
          this.trigger.setAttribute('aria-describedby', this.content.id);

          this.addEventListener('pointerenter', this.onPointerEnter);
          this.addEventListener('pointerleave', this.onPointerLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          this.addEventListener('keydown', this.onKeyDown);
          this.trigger.addEventListener('click', this.onTriggerClick);
        }

        disconnectedCallback() {
          this.close();
        }

        open() {
          if (this.hasAttribute('open')) return;
          this.setAttribute('open', '');
          this.trigger.setAttribute('aria-expanded', 'true');
          this.position();
          document.addEventListener('pointerdown', this.onDocumentPointerDown);
        }

        close() {
          this.pinned = false;
          this.removeAttribute('open');
          if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
          document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        }

        // Shifts the bubble horizontally to keep it inside the viewport.
        position() {
          this.style.removeProperty('--fulfilment-tooltip-shift');
          var rect = this.content.getBoundingClientRect();
          var viewportWidth = document.documentElement.clientWidth;
          var shift = 0;
          if (rect.right > viewportWidth - TOOLTIP_VIEWPORT_MARGIN) {
            shift = viewportWidth - TOOLTIP_VIEWPORT_MARGIN - rect.right;
          }
          if (rect.left + shift < TOOLTIP_VIEWPORT_MARGIN) {
            shift = TOOLTIP_VIEWPORT_MARGIN - rect.left;
          }
          if (shift) this.style.setProperty('--fulfilment-tooltip-shift', shift + 'px');
        }

        onPointerEnter(event) {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.open();
        }

        onPointerLeave(event) {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          if (!this.pinned) this.close();
        }

        onFocusIn(event) {
          if (event.target === this.trigger && this.trigger.matches(':focus-visible')) this.open();
        }

        onFocusOut(event) {
          if (this.hovered || this.contains(event.relatedTarget)) return;
          this.close();
        }

        onKeyDown(event) {
          if (event.key !== 'Escape' || !this.hasAttribute('open')) return;
          this.close();
          this.trigger.focus();
        }

        onTriggerClick() {
          if (this.hasAttribute('open') && this.pinned) {
            this.close();
            return;
          }
          this.open();
          this.pinned = true;
        }

        onDocumentPointerDown(event) {
          if (!this.contains(event.target)) this.close();
        }
      }
    );
  }

  if (!customElements.get('fulfilment-availability')) {
    customElements.define(
      'fulfilment-availability',
      class FulfilmentAvailability extends HTMLElement {
        constructor() {
          super();
          this.rootUrl = this.dataset.rootUrl || '/';
          if (!this.rootUrl.endsWith('/')) this.rootUrl += '/';
          this.deliveryEnabled = this.dataset.deliveryEnabled === 'true';
          this.pickupEnabled = this.dataset.pickupEnabled === 'true';
          this.lowStockThreshold = parseInt(this.dataset.lowStockThreshold, 10);
          if (isNaN(this.lowStockThreshold)) this.lowStockThreshold = 5;

          this.locations = [];
          this.specialOrder = this.dataset.specialOrder === 'true';
          this.variantPolicies = parseJson(this.dataset.variantPolicies) || {};
          this.debugDeliveryEligible = this.dataset.debugDeliveryEligible === 'true';
          this.branchListPopulated = false;
          this.showAvailableOnly = false;
          // undefined = not yet resolved, null = resolved but failed, Set = resolved successfully.
          this.deliveryEligibleLocationIds = undefined;

          this.onVariantChanged = this.onVariantChanged.bind(this);
          this.onChangeStoreClick = this.onChangeStoreClick.bind(this);
          this.onBranchSearchInput = this.onBranchSearchInput.bind(this);
          this.onRegionFilterChange = this.onRegionFilterChange.bind(this);
          this.onAvailableOnlyToggleChange = this.onAvailableOnlyToggleChange.bind(this);
          this.onBranchListClick = this.onBranchListClick.bind(this);
          this.onRetryClick = this.onRetryClick.bind(this);
        }

        connectedCallback() {
          document.addEventListener('variant:changed', this.onVariantChanged);

          // Cache drawer-internal elements now, before DrawerComponent moves the drawer to <body> on open.
          this.branchDrawer = this.querySelector('fulfilment-branch-drawer');
          this.branchListEl = this.querySelector('[data-fulfilment-branch-list]');
          this.branchSearchInput = this.querySelector('[data-fulfilment-branch-search]');
          this.branchEmptyEl = this.querySelector('[data-fulfilment-branch-empty]');
          this.regionFilterSelect = this.querySelector('[data-fulfilment-region-filter]');
          this.availableOnlyToggle = this.querySelector('[data-fulfilment-available-only-toggle]');
          this.specialOrderTemplate = this.querySelector('[data-fulfilment-special-order-template]');
          this.specialOrderInfoTemplate = this.querySelector('[data-fulfilment-special-order-info-template]');
          this.pickupTooltipEl = this.querySelector('[data-fulfilment-pickup-tooltip]');
          this.pickupTitleEl = this.querySelector('[data-fulfilment-pickup-title]');
          this.mismatchMessageEl = this.querySelector('[data-fulfilment-mismatch-message]');

          var changeStoreButton = this.querySelector('[data-fulfilment-change-store]');
          if (changeStoreButton) changeStoreButton.addEventListener('click', this.onChangeStoreClick);

          var selectStoreCta = this.querySelector('[data-fulfilment-select-store-cta]');
          if (selectStoreCta) selectStoreCta.addEventListener('click', this.onChangeStoreClick);

          if (this.branchSearchInput) this.branchSearchInput.addEventListener('input', this.onBranchSearchInput);
          if (this.regionFilterSelect) this.regionFilterSelect.addEventListener('change', this.onRegionFilterChange);
          if (this.availableOnlyToggle) this.availableOnlyToggle.addEventListener('change', this.onAvailableOnlyToggleChange);
          if (this.branchListEl) this.branchListEl.addEventListener('click', this.onBranchListClick);

          this.addEventListener('click', this.onRetryClick);

          this.fetchAvailability(this.dataset.variantId);

          if (this.deliveryEnabled) this.fetchDeliveryEligibleLocations();
        }

        disconnectedCallback() {
          document.removeEventListener('variant:changed', this.onVariantChanged);
        }

        onVariantChanged(event) {
          var variant = event.detail && event.detail.variant;
          if (!variant) return;
          this.dataset.variantId = variant.id;
          this.fetchAvailability(variant.id);
        }

        onChangeStoreClick() {
          this.ensureBranchListReady();
        }

        ensureBranchListReady() {
          this.populateRegionFilter();
          this.renderBranchList();
          this.branchListPopulated = true;
        }

        onBranchSearchInput() {
          this.renderBranchList();
        }

        onRegionFilterChange() {
          this.renderBranchList();
        }

        onAvailableOnlyToggleChange() {
          this.showAvailableOnly = !!(this.availableOnlyToggle && this.availableOnlyToggle.checked);
          this.renderBranchList();
        }

        onBranchListClick(event) {
          var button = event.target.closest('[data-fulfilment-select-branch]');
          if (!button) return;
          this.selectBranch(button.dataset.fulfilmentSelectBranch);
        }

        onRetryClick(event) {
          if (!event.target.closest('[data-fulfilment-retry]')) return;
          this.fetchAvailability(this.dataset.variantId);
        }

        getPreferredLocationId() {
          return getCookie(COOKIE_NAME);
        }

        selectBranch(locationId) {
          setCookie(COOKIE_NAME, locationId, COOKIE_MAX_AGE_DAYS);
          this.renderPickup();
          this.renderBranchList();
          if (this.branchDrawer) this.branchDrawer.hide();
        }

        // Returns the selected variant's inventory policy ('continue' or 'deny'), or undefined if unknown.
        getVariantPolicy() {
          return this.variantPolicies[this.dataset.variantId];
        }

        getStockState(quantity) {
          if (!quantity || quantity <= 0) return 'out-of-stock';
          if (quantity <= this.lowStockThreshold) return 'low-stock';
          return 'in-stock';
        }

        // Returns the available locations flagged delivery-eligible in this.deliveryEligibleLocationIds,
        // or all available locations if that set hasn't resolved.
        getDeliveryLocations(locations) {
          var eligibleIds = this.deliveryEligibleLocationIds;
          return locations.filter(function (location) {
            if (!location.available) return false;
            if (eligibleIds instanceof Set) {
              return eligibleIds.has(extractNumericId(location.location.id));
            }
            return true;
          });
        }

        // Sums quantityAvailable across the delivery locations.
        deriveDeliveryQuantity(locations) {
          return this.getDeliveryLocations(locations).reduce(function (sum, location) {
            return sum + (location.quantityAvailable || 0);
          }, 0);
        }

        // True when a delivery location is available with no stock, the same rule pickup uses for special order.
        hasDeliverySpecialOrder(locations) {
          return this.getDeliveryLocations(locations).some(function (location) {
            return !location.quantityAvailable || location.quantityAvailable <= 0;
          });
        }

        async fetchAvailability(variantId) {
          this.setAttribute('loading', '');

          var variables = {
            id: 'gid://shopify/ProductVariant/' + variantId,
            first: 100,
          };

          try {
            var response = await fetch(this.rootUrl + 'api/' + STOREFRONT_API_VERSION + '/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storeFrontAccessToken,
              },
              body: JSON.stringify({ query: QUERY, variables: variables }),
            });

            if (!response.ok) throw new Error('Storefront API request failed: ' + response.status);

            var result = await response.json();
            if (result.errors && result.errors.length) throw new Error(result.errors[0].message);
            if (!result.data || !result.data.node) throw new Error('No node returned for variant');

            var variant = result.data.node;
            this.locations = variant.storeAvailability.edges.map(function (edge) {
              return edge.node;
            });
            this.specialOrder = variant.currentlyNotInStock;

            this.removeAttribute('loading');
            if (this.deliveryEnabled) this.renderDelivery();
            if (this.pickupEnabled) {
              this.renderPickup();
              if (this.branchListPopulated) this.renderBranchList();
            }
          } catch (error) {
            console.error('[fulfilment-availability]', error);
            this.removeAttribute('loading');
            this.renderError();
          }
        }

        async fetchDeliveryEligibleLocations() {
          try {
            var response = await fetch(this.rootUrl + 'api/' + STOREFRONT_API_VERSION + '/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storeFrontAccessToken,
              },
              body: JSON.stringify({
                query: METAOBJECT_QUERY,
                variables: { type: DELIVERY_ELIGIBLE_METAOBJECT_TYPE, first: 100 },
              }),
            });

            if (!response.ok) throw new Error('Metaobject request failed: ' + response.status);

            var result = await response.json();
            if (result.errors && result.errors.length) throw new Error(result.errors[0].message);

            var nodes = (result.data && result.data.metaobjects && result.data.metaobjects.nodes) || [];
            var eligibleIds = new Set();

            nodes.forEach(function (node) {
              var isEligible = !!node.fulfilmentLocation && node.fulfilmentLocation.value === 'true';
              if (isEligible && node.shopifyLocationId && node.shopifyLocationId.value) {
                eligibleIds.add(extractNumericId(unwrapMetaobjectValue(node.shopifyLocationId.value)));
              }
            });

            this.deliveryEligibleLocationIds = eligibleIds;
          } catch (error) {
            console.error('[fulfilment-availability] delivery-eligible-locations metaobject', error);
            this.deliveryEligibleLocationIds = null;
          }

          if (this.deliveryEnabled && this.locations.length) this.renderDelivery();
          if (this.debugDeliveryEligible && this.branchListPopulated) this.renderBranchList();
        }

        specialOrderInfoHtml() {
          return this.specialOrderInfoTemplate ? this.specialOrderInfoTemplate.innerHTML : '';
        }

        stockStateHtml(state, specialOrderAvailable, withInfo) {
          var strings = window.FoxTheme.fulfilmentAvailabilityStrings;
          var lowStockLabel = specialOrderAvailable ? strings.lowStockSpecialOrder : strings.lowStock;
          var label = state === 'in-stock' ? strings.inStock : state === 'low-stock' ? lowStockLabel : strings.outOfStock;
          return (
            '<span class="fulfilment-availability__badge fulfilment-availability__badge--' +
            state +
            '" data-state="' +
            state +
            '">' +
            escapeHtml(label) +
            '</span>'
          ) + (withInfo && specialOrderAvailable && state === 'low-stock' ? this.specialOrderInfoHtml() : '');
        }

        specialOrderMessageHtml() {
          return this.specialOrderTemplate ? this.specialOrderTemplate.innerHTML : '';
        }

        // Ranks a branch's fulfilment state for the "available only" filter/sort: in-stock and
        // low-stock (by quantityAvailable, highest first), then special-order, then out-of-stock.
        getBranchTier(location) {
          var isSpecialOrder = !!location.available && (!location.quantityAvailable || location.quantityAvailable <= 0);
          if (isSpecialOrder) return 'special-order';
          return this.getStockState(location.quantityAvailable);
        }

        branchStockBadgeHtml(location) {
          var tier = this.getBranchTier(location);
          if (tier === 'special-order') {
            var strings = window.FoxTheme.fulfilmentAvailabilityStrings;
            return (
              '<span class="fulfilment-availability__badge fulfilment-availability__badge--low-stock" data-state="special-order-available">' +
              escapeHtml(strings.outOfStockSpecialOrder) +
              '</span>'
            );
          }
          return this.stockStateHtml(tier, this.getVariantPolicy() === 'continue');
        }

        isDeliveryEligibleDebugMarkerShown(location) {
          return (
            this.debugDeliveryEligible &&
            this.deliveryEligibleLocationIds instanceof Set &&
            this.deliveryEligibleLocationIds.has(extractNumericId(location.location.id))
          );
        }

        renderDelivery() {
          var panel = this.querySelector('[data-fulfilment-panel="delivery"]');
          if (!panel) return;
          var statusEl = panel.querySelector('[data-fulfilment-status]');
          if (!statusEl) return;

          panel.classList.toggle('fulfilment-availability__panel--special-order', !!this.specialOrder);

          if (this.specialOrder) {
            this.deliveryState = 'special-order';
            statusEl.innerHTML = this.specialOrderMessageHtml();
            this.updateMismatchTooltip();
            return;
          }

          var quantity = this.deriveDeliveryQuantity(this.locations);

          var policy = this.getVariantPolicy();
          var canSpecialOrder = policy === 'continue';
          var noStockSpecialOrder = policy === undefined ? this.hasDeliverySpecialOrder(this.locations) : canSpecialOrder;

          if (quantity <= 0 && noStockSpecialOrder) {
            panel.classList.add('fulfilment-availability__panel--special-order');
            this.deliveryState = 'special-order';
            statusEl.innerHTML = this.specialOrderMessageHtml();
            this.updateMismatchTooltip();
            return;
          }

          this.deliveryState = this.getStockState(quantity);
          statusEl.innerHTML = this.stockStateHtml(this.deliveryState, canSpecialOrder, true);
          this.updateMismatchTooltip();
        }

        renderPickup() {
          var panel = this.querySelector('[data-fulfilment-panel="pickup"]');
          if (!panel) return;
          var statusEl = panel.querySelector('[data-fulfilment-status]');
          var branchRow = panel.querySelector('[data-fulfilment-branch-row]');
          var branchNameEl = panel.querySelector('[data-fulfilment-branch-name]');
          var contentEl = panel.querySelector('[data-fulfilment-pickup-content]');
          var ctaButton = panel.querySelector('[data-fulfilment-select-store-cta]');
          var changeStoreLink = panel.querySelector('[data-fulfilment-change-store]');
          if (!statusEl) return;

          if (!this.locations.length) {
            if (ctaButton) ctaButton.hidden = true;
            if (contentEl) contentEl.hidden = false;
            if (changeStoreLink) changeStoreLink.hidden = true;
            this.pickupState = 'out-of-stock';
            statusEl.innerHTML = this.stockStateHtml('out-of-stock');
            if (branchRow) branchRow.hidden = true;
            this.updateMismatchTooltip();
            return;
          }

          var preferredId = this.getPreferredLocationId();
          var preferred =
            preferredId &&
            this.locations.find(function (location) {
              return location.location.id === preferredId;
            });

          if (!preferred) {
            if (ctaButton) ctaButton.hidden = false;
            if (contentEl) contentEl.hidden = true;
            if (changeStoreLink) changeStoreLink.hidden = true;
            this.pickupState = 'no-store-selected';
            this.updateMismatchTooltip();
            return;
          }

          if (ctaButton) ctaButton.hidden = true;
          if (contentEl) contentEl.hidden = false;
          if (changeStoreLink) changeStoreLink.hidden = false;

          if (branchRow && branchNameEl) {
            branchNameEl.textContent = preferred.location.name;
            branchRow.hidden = false;
          }

          var showSpecialOrder = !!preferred.available && (!preferred.quantityAvailable || preferred.quantityAvailable <= 0);

          panel.classList.toggle('fulfilment-availability__panel--special-order', showSpecialOrder);

          if (showSpecialOrder) {
            this.pickupState = 'special-order';
            statusEl.innerHTML = this.specialOrderMessageHtml();
            this.updateMismatchTooltip();
            return;
          }

          this.pickupState = this.getStockState(preferred.quantityAvailable);
          statusEl.innerHTML = this.stockStateHtml(this.pickupState, this.getVariantPolicy() === 'continue', true);
          this.updateMismatchTooltip();
        }

        updateMismatchTooltip() {
          if (!this.pickupTooltipEl) return;
          var shouldShow =
            this.deliveryEnabled &&
            this.pickupEnabled &&
            this.deliveryState === 'out-of-stock' &&
            (this.pickupState === 'in-stock' || this.pickupState === 'low-stock');
          if (this.mismatchMessageEl) this.mismatchMessageEl.hidden = !shouldShow;

          var hasPickupMessage = this.pickupTooltipEl.dataset.hasMessage === 'true';
          var tooltipVisible = hasPickupMessage || (shouldShow && !!this.mismatchMessageEl);
          this.pickupTooltipEl.hidden = !tooltipVisible;
          if (this.pickupTitleEl) this.pickupTitleEl.hidden = tooltipVisible;
          if (!tooltipVisible) {
            var tooltip = this.pickupTooltipEl.querySelector('fulfilment-tooltip');
            if (tooltip && tooltip.close) tooltip.close();
          }
        }

        populateRegionFilter() {
          if (!this.regionFilterSelect) return;

          var previousValue = this.regionFilterSelect.value;
          var strings = window.FoxTheme.fulfilmentAvailabilityStrings;

          var regions = Array.from(
            new Set(
              this.locations
                .map(function (location) {
                  return location.location.address && location.location.address.province;
                })
                .filter(Boolean)
            )
          ).sort();

          this.regionFilterSelect.innerHTML =
            '<option value="">' +
            escapeHtml(strings.allRegions) +
            '</option>' +
            regions
              .map(function (region) {
                return '<option value="' + escapeHtml(region) + '">' + escapeHtml(region) + '</option>';
              })
              .join('');

          if (previousValue && regions.indexOf(previousValue) !== -1) {
            this.regionFilterSelect.value = previousValue;
          }
        }

        renderBranchList() {
          var list = this.branchListEl;
          var emptyEl = this.branchEmptyEl;
          var searchInput = this.branchSearchInput;
          if (!list) return;

          var query = ((searchInput && searchInput.value) || '').trim().toLowerCase();
          var selectedRegion = (this.regionFilterSelect && this.regionFilterSelect.value) || '';
          var preferredId = this.getPreferredLocationId();

          var filtered = this.locations.filter((location) => {
            if (selectedRegion && (!location.location.address || location.location.address.province !== selectedRegion)) {
              return false;
            }
            if (this.showAvailableOnly && this.getBranchTier(location) === 'out-of-stock') {
              return false;
            }
            if (!query) return true;
            var haystack = (location.location.name + ' ' + formatAddress(location.location.address)).toLowerCase();
            return haystack.indexOf(query) !== -1;
          });

          if (this.showAvailableOnly) {
            var tierRank = { 'in-stock': 0, 'low-stock': 1, 'special-order': 2, 'out-of-stock': 3 };
            filtered = filtered.slice().sort((a, b) => {
              var tierDiff = tierRank[this.getBranchTier(a)] - tierRank[this.getBranchTier(b)];
              if (tierDiff !== 0) return tierDiff;
              return (b.quantityAvailable || 0) - (a.quantityAvailable || 0);
            });
          }

          list.innerHTML = filtered
            .map((location) => {
              var isSelected = location.location.id === preferredId;
              return (
                '<li class="fulfilment-branch-list__item">' +
                '<div class="fulfilment-branch-list__info">' +
                '<h3 class="h5 fulfilment-branch-list__name">' +
                escapeHtml(location.location.name) +
                (this.isDeliveryEligibleDebugMarkerShown(location) ? ' <span class="fulfilment-branch-list__debug-marker">*</span>' : '') +
                '</h3>' +
                this.branchStockBadgeHtml(location) +
                '<address class="fulfilment-branch-list__address text-subtext text-sm">' +
                escapeHtml(formatAddress(location.location.address)) +
                '</address>' +
                '</div>' +
                (isSelected
                  ? '<span class="fulfilment-branch-list__selected">' +
                    escapeHtml(window.FoxTheme.fulfilmentAvailabilityStrings.selected) +
                    '</span>'
                  : '<button type="button" class="btn btn--secondary fulfilment-branch-list__select" data-fulfilment-select-branch="' +
                    escapeHtml(location.location.id) +
                    '">' +
                    escapeHtml(window.FoxTheme.fulfilmentAvailabilityStrings.select) +
                    '</button>') +
                '</li>'
              );
            })
            .join('');

          if (emptyEl) emptyEl.hidden = filtered.length > 0;
        }

        renderError() {
          var template = this.querySelector('[data-fulfilment-error-template]');
          if (!template) return;
          ['delivery', 'pickup'].forEach((type) => {
            var panel = this.querySelector('[data-fulfilment-panel="' + type + '"]');
            var statusEl = panel && panel.querySelector('[data-fulfilment-status]');
            if (statusEl) statusEl.innerHTML = template.innerHTML;
          });
        }
      }
    );
  }

  if (!customElements.get('fulfilment-branch-drawer') && typeof DrawerComponent !== 'undefined') {
    customElements.define(
      'fulfilment-branch-drawer',
      class FulfilmentBranchDrawer extends DrawerComponent {
        constructor() {
          super();
        }
      }
    );
  }
})();
